<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>发布配置</span>
      <el-button size="mini" @click="add">新增</el-button>
    </div>

    <div class="block">
      <el-timeline>
        <el-timeline-item v-for="(item, index) in tableData" :key="index" :type="item.status === 1 ? 'success' :''" :timestamp="item.date+'['+(item.status === 1 ? '已发布' : '未发布')+']'" placement="top">
          <el-card>
            <h3>版本:{{ item.version }}</h3>
            <h3>更新内容:</h3>
            <p>
              {{ item.mark }}
            </p>
            <p>{{ item.user }} 提交于 {{ item.created_at }}</p>
            <p>
              <el-button v-if="item.status ===0" size="mini" @click="edit(item)">编辑</el-button>
              <el-button v-if="item.status ===0" :loading="loading" size="mini" type="success" @click="publish(item)">发布</el-button>
              <el-button size="mini" type="danger" @click="del(item.id)">删除</el-button>
            </p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>

    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="版本">
          <el-select v-model="form.version" placeholder="请选择活动区域">
            <el-option v-for="(item,index) in versionData" :key="index" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="更新内容">
          <el-input v-model="form.mark" :rows="10" type="textarea" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onsubmit(false)">保存</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

  </el-card>
</template>

<script>
import { getVersionCfg } from '@/api/config/version-set'
import { delCfg, getCfg, updateCfg } from '@/api/config/publish-cfg'

export default {
  name: 'PublishConfig',
  data() {
    return {
      loading: false,
      versionData: [],
      form: {
        version: '',
        mark: '',
        status: 0
      },
      drawer: false,
      direction: 'rtl',
      tableData: []
    }
  },
  created() {
    this.getVersion()
    this.getTables()
  },
  methods: {
    add() {
      this.drawer = true
      this.form = {
        version: '',
        mark: '',
        status: 0
      }
    },
    edit(row) {
      this.drawer = true
      this.form = row
    },
    publish(row) {
      this.loading = true
      this.form = row
      this.$confirm('确认要发布吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onsubmit(true)
        this.loading = false
      })
    },
    del(id) {
      delCfg({ id: id }).then(res => {
        this.msgSuccess('删除成功')
        this.getTables()
      })
    },
    getVersion() {
      getVersionCfg().then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.versionData.unshift({ label: item, value: item })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCfg().then(res => {
        this.tableData = res.data
      })
    },
    onsubmit(isPub = false) {
      this.form.status = 0
      if (isPub) {
        this.form.status = 1
      }
      if (!this.form.version) {
        this.msgError('请选择版本')
        return
      }

      if (!this.form.mark) {
        this.msgError('更新内容不能为空')
        return
      }

      const data = JSON.stringify(this.form)
      updateCfg({ data: data }).then(res => {
        this.drawer = false
        this.msgSuccess('更新成功')
        this.getTables()
      })
    }
  }
}
</script>

<style scoped>

</style>
